<template>
  <div>
      <div>
        <div style="height:90%;">
            <div class="search-box flex flex-wrap">
                <div class="flex align-center search-item mar-btm-10" style="width:33.33%;">
                    <div style="width:120px;text-align: right;">发布栏目：</div>
                    <el-select v-model="paramData.categoryId" clearable allow-create style="width:100%;" placeholder="请选择上级栏目名称"
                        @change="handleCategoryChange">
                        <el-option
                        v-for="item in selectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex align-center search-item mar-btm-10" style="width:33.33%;">
                    <div style="width:120px;text-align: right;">标题/内容：</div>
                    <el-input placeholder="请输入标题/内容" v-model="paramData.titleOrContent" style="width:100%;"></el-input>
                </div>
                <div class="flex align-center search-item mar-btm-10" style="width:33.33%;">
                    <div style="width:120px;text-align:right;">状态：</div>
                    <el-select v-model="paramData.status" clearable allow-create style="width:100%;" placeholder="请选择状态">
                        <el-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.status"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex align-center search-item mar-btm-10" style="width:33.33%;">
                    <div style="width:120px;text-align:right;">发布对象：</div>
                    <el-select v-model="paramData.publishTo" multiple clearable style="width:100%;" allow-create placeholder="请选择发布对象">
                        <el-option
                        v-for="item in publishObj"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex align-center search-item mar-btm-10" style="width:33.33%;">
                    <div style="width:120px;text-align: right;">发布类型：</div>
                    <el-select v-model="paramData.type" clearable allow-create style="width:100%;" placeholder="请选择发布类型">
                        <el-option
                        v-for="item in publishType"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="flex align-center search-item mar-btm-10" style="width:33.33%;">
                    <div style="width:120px;text-align: right;">发布时间：</div>
                    <el-date-picker
                        id="picker"
                        type="date"
                        placeholder="请选择起始时间"
                        value-format="yyyy-MM-dd"
                        v-model="paramData.publishBeginTime"
                        style="width: 46%;"
                    >
                    </el-date-picker>
                    <div style="width: 8%;padding:0 1.5%">至</div>
                    <el-date-picker
                        id="picker"
                        type="date"
                        placeholder="请选择结束时间"
                        value-format="yyyy-MM-dd"
                        v-model="paramData.publishEndTime"
                        style="width: 46%;"
                    >
                    </el-date-picker>
                </div>
                <div class="flex align-center search-item mar-btm-10" style="width:100%;justify-content: flex-end;">
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch" style="float:right;height:40px;">查询</el-button>
                </div>
            </div>
            <div class="flex just-between" style="margin-bottom:20px;">
                <div>
                    <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">增加</el-button>
                </div>
            </div>
            <el-table
                :data='dataList'
                :header-cell-style="{textAlign: 'center',background: '#409EFF',color: '#fff'}"
                :cell-style="{textAlign: 'center'}"
                style="width:100%;border:none;"
            >
                <el-table-column type='index' label='序号' width="60"></el-table-column>
                <el-table-column prop="category.name" label="栏目" width="100"></el-table-column>
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="publishTime" width="100" label="发布时间"></el-table-column>
                <el-table-column prop="expireTime" width="100" label="有效期"></el-table-column>
                <el-table-column prop="publishToName" width="200" label="发布对象"></el-table-column>
                <el-table-column prop="publishModel" width="100" label="发布模块">
                    <template slot-scope="scope">
                        <div>{{scope.row.publishModel === 1 ? '本模块' : '新闻通知及本模块'}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="type" width="100" label="发布类型">
                    <template slot-scope="scope">
                        <div>{{scope.row.type === '1' ? '普通通知' : '图片新闻'}}</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="createUser" width="100" label="创建人"></el-table-column> -->
                <el-table-column prop="createTime" width="100" label="创建时间"></el-table-column>
                <el-table-column label="置顶" prop="top">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.top"
                            :inactive-value="0"
                            :active-value="1"
                            @change="changeTop(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="发布" prop="status">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status"
                            :inactive-value="'0'"
                            :active-value="'1'"
                            @change="changeStatus(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="publishStatus" label="发布状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status ==='0'">未发布</span>
                        <span v-if="scope.row.status ==='1'">已发布</span>
                        <span v-if="scope.row.publishStatus ==='2'">，未开始</span>
                        <span v-if="scope.row.publishStatus ==='3'">，已结束</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                        <el-button size="small" icon="el-icon-edit" style="margin-right:5px;" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                style="margin:20px 0;"
                layout='->, prev,pager,next,total,sizes,jumper'
                @size-change='changeSize'
                @current-change='changeCurrent'
                :page-sizes="['10','20','30','40','50']"
                :page-size="catalogQuery.pageSize"
                :current-page='catalogQuery.pageNum'
                :total='total'
            >
            </el-pagination>
        </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable prefer-const */
/* eslint-disable no-debugger */
export default {
    data() {
        return {
            total: 0,
            dataList: [],
            catalogQuery: {
                pageSize: 10,
                pageNum: 1
            },
            statusList: [
                {
                    status: '未发布',
                    value: '0'
                },
                {
                    status: '已发布',
                    value: '1'
                },
                {
                    status: '未开始',
                    value: '2'
                },
                {
                    status: '已结束',
                    value: '3'
                }
            ],
            selectList: [],
            publishObj: [
                {
                    name: '系统用户',
                    value: 1
                },
                {
                    name: '访客',
                    value: 2
                },
                {
                    name: '校内网',
                    value: 3
                }
            ],
            publishType: [
                {
                    name: '普通通知',
                    value: 1
                },
                {
                    name: '图片新闻',
                    value: 2
                }
            ],
            paramData: {
                type: '',
                status: '',
                publishEndTime: '',
                publishBeginTime: '',
                titleOrContent: '',
                categoryId: '',
                categoryIds: []
            }
        }
    },
    methods: {
        handleCategoryChange(value) {
            if (!value) {
                this.paramData.categoryIds = [];
                this.paramData.categoryId = '';
                return;
            }
            // 过滤当前选中的父级职责
            this.selectList.forEach((item) => {
                if (value === item.id && !item.children) {
                    const param = {
                        pageSize: 10000,
                        pageNum: 1,
                        parentId: value
                    }
                    this.$api.website.getCategoryPageList(param).then(res => {
                        if (res.code === 200) {
                            item.children = res.data.content
                            this.paramData.categoryIds = item.children.map((item) => item.id);
                            this.paramData.categoryIds.push(item.id);
                        }
                    })
                } else if (item.children) {
                    this.paramData.categoryIds = item.children.map((item) => item.id);
                    this.paramData.categoryIds.push(item.id);
                }
            })
        },
        changeTop (data) {
            const param = {
                id: data.id
            }
            if (data.top === 1) {
                this.$api.publish.editTop(param).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '置顶成功'
                        })
                        this.handleSearch()
                    }
                })
            } else {
                this.$api.publish.cancelTop(param).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '取消置顶成功'
                        })
                        this.handleSearch()
                    }
                })
            }
        },
        changeStatus (data) {
            const param = {
                id: data.id
            }
            if (data.status === '0') {
                this.$api.publish.cancelStatus(param).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '取消发布成功'
                        })
                        this.handleSearch()
                    }
                })
            } else {
                this.$api.publish.editStatus(param).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '发布成功'
                        })
                        this.handleSearch()
                    }
                })
            }
        },
        changeSize (value) {
            this.catalogQuery.pageSize = value
            this.getFbtzList()
        },
        changeCurrent (value) {
            this.catalogQuery.pageNum = value
            this.getFbtzList()
        },
        getFbtzList (data) {
            let param = {
                pageSize: this.catalogQuery.pageSize,
                pageNum: this.catalogQuery.pageNum
            }
            if (!data) {
                data = {}
                for (let i in this.paramData) {
                    if (this.paramData[i]) {
                        data[i] = this.paramData[i]
                    }
                }
            }
            param = Object.assign(param, data)
            if (this.paramData.categoryIds) {
                param.categoryId = this.paramData.categoryIds;
            }
            this.$api.publish.getList(param).then(res => {
                console.log(res)
                if (res.code === 200) {
                    res.data.content.forEach(item => {
                        item.publishTime = item.publishTime ? item.publishTime.split('T')[0] : ''
                        item.expireTime = item.expireTime ? item.expireTime.split('T')[0] : ''
                        item.createTime = item.createTime ? item.createTime.split('T')[0] : ''
                        item.publishToName = item.publishTo.replace("1", "系统用户").replace("2", "访客").replace("3", "校内网")
                    });
                    this.dataList = res.data.content
                    this.total = res.data.totalElements
                }
            })
        },
        handleSearch () {
            const data = {}
            for (let i in this.paramData) {
                if (this.paramData[i]) {
                    data[i] = this.paramData[i]
                }
            }
            this.getFbtzList(data)
        },
        handleAdd () {
            this.$router.push({
                path: '/manage/publishNews/add'
            })
        },
        handleDelete (data) {
            this.$confirm('此操作将彻底删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const param = {
                    id: data.id
                }
                this.$api.publish.deldeteNotice(param).then(res => {
                    if (res.code === 200) {
                        this.handleSearch()
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        })
                    }
                })
            }).catch(() => {
                this.$message({
                type: 'info',
                message: '取消删除'
                })
            })
        },
        getSelectList () {
            const param = {
                pageSize: 20,
                pageNum: 1,
                root: true
            }
            this.$api.website.getCategoryPageList(param).then(res => {
                if (res.code === 200) {
                    this.selectList = res.data.content
                }
            })
        },
        handleEdit (data) {
            this.$router.push({
                name: '发布通知页',
                params: data
            })
        }
    },
    mounted() {
        this.getFbtzList()
        this.getSelectList()
    }
}
</script>

<style scoped lang='less'>
.search-item{
    width: 320px;
}
.mar-btm-10{
    margin-bottom: 10px;
}
</style>
